import * as React from "react";
import * as ReactDOM from "react-dom";

import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// var mountNode = document.getElementById("app");
// ReactDOM.render(<App />, mountNode);
